module.exports = __webpack_public_path__ + "static/umberlee-symbol-SCAG-deb34fd7fb39ae37c39e576d1ed1687e.png";